const { connect } = require('react-redux');
const gamePauseComponent = require('../component/gamePauseComponent').default;
const { actions } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    const { screenState, playerState, gameState } = state;
    return {
        isModalOpen: screenState.modal === modalType.MODAL_GAME_PAUSE,
        playerState,
        gameState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleBackClick: (elapsedTime, skillElapsedTime) => {
            dispatch(actions.modalDisable());
            dispatch(actions.gameResume(elapsedTime, skillElapsedTime));
            // timer on game restart
        }
    };
};

export const GamePauseContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(gamePauseComponent);